import { useInView } from '@/lib/hooks';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

export default function AboutServiceInfo() {
    const t = useTranslations('SingleService');
    const { isInView, elementRef } = useInView();

    return (
        <div className="w-full flex max-lg:flex-col justify-between gap-11 pt-7 lg:pt-[60px] border-t border-light-grey">
            {services(t).map(({ imageSrc, title, description }, index) => (
                <div className="flex flex-col gap-7 xl:gap-[60px] max-w-[365px]" key={index} ref={elementRef}>
                    <div className="flex gap-4">
                        <div>
                            <Image
                                className={cn(
                                    'max-lg:hidden object-contain opacity-0 transition-all ease-in-out duration-2000 min-w-[150px] h-[160px]',
                                    isInView && 'opacity-100',
                                )}
                                src={imageSrc}
                                alt="Service"
                                width={150}
                                height={160}
                            />
                            <Image
                                className={cn(
                                    'lg:hidden object-contain opacity-0 transition-all ease-in-out duration-2000 min-w-[110px] h-[120px]',
                                    isInView && 'opacity-100',
                                )}
                                src={imageSrc}
                                alt="Service"
                                width={110}
                                height={120}
                            />
                        </div>
                        <div className="w-fit leading-tight mt-6">
                            <h4 className="text-h4 font-medium">{title}</h4>
                        </div>
                    </div>
                    <p className="text-h5 font-normal leading-tight">{description}</p>
                </div>
            ))}
        </div>
    );
}

const services = (t: Function) => [
    {
        imageSrc: '/img/services/6.webp',
        title: t('innovativeTechnologies'),
        description: t('weLeverage'),
    },
    {
        imageSrc: '/img/services/7.webp',
        title: t('fastTurnaround'),
        description: t('efficientProcesses'),
    },
    {
        imageSrc: '/img/services/5.webp',
        title: t('expertTeam'),
        description: t('ourTeam'),
    },
];
